import {createRouter, createWebHistory } from "vue-router";
import { getUserInfo } from "@/api/index";
import store from '@/store';
const routerHistory  = createWebHistory()
/* Layout */
import Layout from "@/layout";
import Layout2 from "@/layout/indexTwo.vue";
import Layout3 from "@/layout/indexThree.vue";
import {marketStatisticsRouter} from "./marketStatisticsRouter";
// 公共路由 无需登录
const noLoginRoutes = [
  {
    path: "/loginWx",
    name: 'loginWx',
    component: () => import("@/views/loginWx"),
    meta: { title: '微信授权' },
    hidden: true,
  },
  
]
export const constantRoutes = [
  {
    path: "/",
    redirect: {name: 'entranceView'},
    hidden: true,
  },
  {
    path: "/entranceView",
    name: 'entranceView',
    component: () => import("@/views/entranceView"),
    meta: { title: '日报入口', disableBack: true },
    hidden: true,
  },
  {
    path: '/market',
    component: Layout2,
    redirect: 'market/home',
    hidden: true,
    // 需要登录的路由
    children: [
      {
        path: "home",
        name: 'marketHome',
        component: () => import("@/views/market/home"),
        meta: { title: '首页', disableBack: false },
        hidden: true,
      },
      {
        path: "myCenter",
        name: 'marketMyCenter',
        component: () => import("@/views/market/myCenter"),
        meta: { title: '我的' },
        hidden: true,
      },
      {
        path: "todayList",
        name: 'marketTodayList',
        component: () => import("@/views/market/todayList"),
        meta: { title: '日报列表',  disableBack: true },
        hidden: true,
      },
      {
        path: 'statisticsDay',
        name: 'marketStatisticsDay',
        component: () => import("@/views/market/statisticsDay"),
        meta: { title: '日报统计' },
        hidden: true,
      },
      {
        path: 'statisticsDaily',
        name: 'marketStatisticsDaily',
        component: () => import("@/views/market/statisticsDaily"),
        meta: { title: '日报统计' },
        hidden: true,
      },
      {
        path: 'statisAttendance',
        name: 'marketStatisAttendance',
        component: () => import("@/views/market/statisAttendance"),
        meta: { title: '考勤统计' },
        hidden: true,
      },
      {
        path: 'addDaily',
        name: 'marketAddDaily',
        component: () => import("@/views/market/addDaily"),
        meta: { title: '新增日报' },
        hidden: true,
      },
      {
        path: 'dailyDetail',
        name: 'marketDailyDetail',
        component: () => import("@/views/market/dailyDetail"),
        meta: { title: '日报详情' },
        hidden: true,
      },
      {
        path: 'addLinkMan',
        name: 'marketAddLinkMan',
        component: () => import("@/views/market/addLinkMan"),
        meta: { title: '新增单位信息' },
        hidden: true,
      },
      {
        path: 'writeWeekly',
        name: 'marketWriteWeekly',
        component: () => import("@/views/market/writeWeekly"),
        meta: { title: '周报' },
        hidden: true,
      },
      {
        path: 'weeklyList',
        name: 'marketWeeklyList',
        component: () => import("@/views/market/weeklyList"),
        meta: { title: '周报列表' },
        hidden: true,
      },
      {
        path: 'shareList',
        name: 'marketShareList',
        component: () => import("@/views/market/shareList"),
        meta: { title: '日报' },
        hidden: true,
      },
      {
        path: 'addAttendance',
        name: 'marketAddAttendance',
        component: () => import("@/views/market/addAttendance"),
        meta: { title: '添加考勤' },
        hidden: true,
      },
    ],
  },
  {
    path: "/technical",
    component: Layout,
    redirect: 'technical/home',
    hidden: true,
    // 需要登录的路由
    children: [
      {
        path: "home",
        name: 'home',
        component: () => import("@/views/technical/home"),
        meta: { title: '首页', disableBack: false },
        hidden: true,
      },
      {
        path: "myCenter",
        name: 'myCenter',
        component: () => import("@/views/technical/myCenter"),
        meta: { title: '我的' },
        hidden: true,
      },
      {
        path: "todayList",
        name: 'todayList',
        component: () => import("@/views/technical/todayList"),
        meta: { title: '日报列表',  disableBack: true },
        hidden: true,
      },
      {
        path: 'statisticsDay',
        name: 'statisticsDay',
        component: () => import("@/views/technical/statisticsDay"),
        meta: { title: '日报统计' },
        hidden: true,
      },
      {
        path: 'statisticsDaily',
        name: 'statisticsDaily',
        component: () => import("@/views/technical/statisticsDaily"),
        meta: { title: '日报统计' },
        hidden: true,
      },
      {
        path: 'statisAttendance',
        name: 'statisAttendance',
        component: () => import("@/views/technical/statisAttendance"),
        meta: { title: '考勤统计' },
        hidden: true,
      },
      {
        path: 'addDaily',
        name: 'addDaily',
        component: () => import("@/views/technical/addDaily"),
        meta: { title: '新增日报' },
        hidden: true,
      },
      {
        path: 'dailyDetail',
        name: 'dailyDetail',
        component: () => import("@/views/technical/dailyDetail"),
        meta: { title: '日报详情' },
        hidden: true,
      },
      {
        path: 'addLinkMan',
        name: 'addLinkMan',
        component: () => import("@/views/technical/addLinkMan"),
        meta: { title: '新增单位信息' },
        hidden: true,
      },
      {
        path: 'writeWeekly',
        name: 'writeWeekly',
        component: () => import("@/views/technical/writeWeekly"),
        meta: { title: '周报' },
        hidden: true,
      },
      {
        path: 'weeklyList',
        name: 'weeklyList',
        component: () => import("@/views/technical/weeklyList"),
        meta: { title: '周报列表' },
        hidden: true,
      },
      {
        path: 'shareList',
        name: 'shareList',
        component: () => import("@/views/technical/shareList"),
        meta: { title: '日报' },
        hidden: true,
      },
      {
        path: 'addAttendance',
        name: 'addAttendance',
        component: () => import("@/views/technical/addAttendance"),
        meta: { title: '添加考勤' },
        hidden: true,
      },
    ],
  },
  {
    path: "/marketStatistics",
    component: Layout3,
    redirect: 'marketStatistics/home',
    hidden: true,
    // 需要登录的路由
    children: [
      ...marketStatisticsRouter
    ]
  },
  {
    path: '/bindDept',
    name: 'bindDept',
    component: () => import("@/views/bindDept"),
    meta: { title: '绑定部门' },
    hidden: true,
  },
  {
    path: "/projectStatistics",
    name: 'projectStatistics',
    component: () => import("@/views/projectStatistics/projectStatistics"),
    meta: { title: '项目图表统计' },
    hidden: true,
  },
  {
    path: "/projectManager",
    name: 'projectManager',
    component: () => import("@/views/projectManager/projectManager"),
    meta: { title: '项目报备' },
    hidden: true,
  },
  {
    path: "/addProject",
    name: 'addProject',
    component: () => import("@/views/projectManager/addProject"),
    meta: { title: '添加项目',disableBack: false },
    hidden: true,
  },
  {
    path: "/editProject",
    name: 'editProject',
    component: () => import("@/views/projectManager/editProject"),
    meta: { title: '编辑',disableBack: false },
    hidden: true,
  },
  ...noLoginRoutes
]
const router = createRouter({
  history: routerHistory,
  routes: constantRoutes,
  scrollBehavior: () => {
    // 禁止返回
    let arr = ['home', 'todayList', 'statisticsDaily', 'weeklyList']
    if(arr.some(item => document.URL.includes(item)))
    history.pushState(null, null, document.URL)
  }
});
router.beforeEach(async (to, from, next) => {
  if (noLoginRoutes.map( item =>item.path).includes(to.path)){
    next()
  } else {
    if (localStorage.getItem('token')) {
      let res = await getUserInfo()
      store.commit('user/SET_USER', res.data.info)
    }
    next()
  }
})
export default router;